<template>
  <div class="coupon-recive" style="background: #fff">
    <div v-if="loading" style="text-align: center; padding: 40px">
      <van-loading color="#000" size="30px" type="spinner" vertical>
        加载中...
      </van-loading>
    </div>
    <!-- <div v-else class="coupon-detail">
      <div class="info flex flex-align-center">
        <div class="money">¥{{ moneyStr(detail.DiscountAmount) }}</div>
        <div class="title flex-1">{{ detail.PackageName }}</div>
      </div>
      <a class="recive-btn" href="javascript:;" @click="onSubmit">立即领取</a>
    </div> -->
    <div v-else-if="detail">
      <div class="coupon-content">
        <div class="coupon">
          <div class="coupon-text1">
            <div class="coupon-money">
              <span class="icon">￥</span>
              <span class="price">
                {{ moneyStr(detail.DiscountAmount || 0) }}
              </span>
            </div>
            <div class="coupon-name">{{ detail.PackageName }}</div>
          </div>
          <div class="coupon-text2">
            <div>【{{ detail.ProductName }}】 专属券</div>
            <div>
              使用期限：{{ detail.EffectiveTime }} ~
              {{ detail.Deadline || '长期有效' }}
            </div>
          </div>
        </div>
        <!-- 免费发放 -->
        <van-button
          v-if="detail.ReceiveMode === 0"
          class="van-btn"
          color="#1bba1a"
          @click="freerReciveCoupon"
        >
          <span v-if="detail.SaleConfig && detail.SaleConfig.Price > 0">
            {{ moneyStr(detail.SaleConfig && detail.SaleConfig.Price) }}元
          </span>
          领取优惠券
        </van-button>

        <!-- 付费买 -->
        <van-button
          v-if="detail.ReceiveMode === 1 && detail.PackageStatus !== 2"
          class="van-btn"
          color="#1bba1a"
          @click="payReciveCoupon"
        >
          支付{{
            moneyStr((detail.SaleConfig && detail.SaleConfig.Price) || 0)
          }}元，即可获得优惠券
        </van-button>
        <!-- 付费去使用 -->
        <van-button
          v-if="detail.ReceiveMode === 1 && detail.PackageStatus === 2"
          class="van-btn"
          color="#1bba1a"
          @click="payGoUseConpon"
        >
          去使用
        </van-button>
        <div
          v-if="
            detail.SaleConfig &&
            detail.SaleConfig.CountDownMsec &&
            detail.SaleConfig.CountDownMsec != '0' &&
            detail.PackageStatus !== 2
          "
          class="count-down"
        >
          <span class="text">活动倒计时</span>
          <van-count-down
            v-if="detail.SaleConfig.CountDownMsec >= 86400000"
            class="time"
            format="DD天HH时mm分ss秒"
            :time="+detail.SaleConfig.CountDownMsec"
          />
          <van-count-down
            v-else
            class="time"
            format="HH时mm分ss秒"
            :time="+detail.SaleConfig.CountDownMsec"
          />
        </div>
      </div>
    </div>
    <van-empty v-else description="来晚一步，下次记得早点来哦~" image="error" />
    <PayStatus ref="REFPayStatus" />
  </div>
</template>
<script>
  import store from '@/store'
  import { Toast, CountDown, Notify } from 'vant'
  import { wxShare } from '@/utils/index'
  import { moneyStr, dateFormat } from '@/utils/filters'
  import storage from '@/utils/storage'
  import qs from 'qs'
  import PayStatus from '../pay/components/PayStatus.vue'
  export default {
    components: {
      [CountDown.name]: CountDown,
      PayStatus,
    },
    data() {
      return {
        moneyStr,
        PackageName: '',
        submitLoading: false,
        detail: {},
        loading: false,
        hasDate: false,
        ownDetailId: '',
        form: {
          // userName: '',
          // phone: '',
          packageId: '',
          packageDetailId: '',
          secret: '',
        },
        couponDetail: {},
        HasPaymentAbility: false, //是否开通支付
        H5Url: '',
        code: '',
        openid: this.$route.query.openid || storage.get('openid'),
      }
    },
    async mounted() {
      const query = this.$route.query
      let url = await store.getters['system/getH5Url']
      if (query.detailId) {
        url += `home/#/pagesPay/settlement/coupon?secret=${query.secret}&detailId=${query.detailId}`
      } else {
        url += `home/#/pagesPay/settlement/coupon?packageId=${query.packageId}`
      }

      location.href = url

      //return
      //如果有code 说明微信登录回调回来了
      this.code = this.getUrlKey('code')
      this.loading = true
      // 没有code 且没有openid 先拿code 换openid
      if (!this.code && !this.openid) {
        this.getCode()
        return
      }
      // 有code 没有openid 则调接口换openid
      if (!this.openid && this.code) {
        this.getWXOpenId(this.code)
        return
      }
      this.loading = false
      this.init()
    },
    methods: {
      //判断是否需要审核
      isExamine() {
        const toast = Toast.loading({
          message: '加载中...',
          duration: 0,
          forbidClick: true,
        })
        const params = {
          productId: this.detail.ProductId,
        }
        let hasExam = false
        return new Promise((resolve, reject) => {
          store
            .dispatch('service/GetProductWorkflow', params)
            .then((data) => {
              console.log('data', data)
              toast.clear()
              const { Code, Message, Data } = data
              hasExam = Data && Data.includes('AdvancedApproving')
              if (hasExam) {
                Toast('报名产品前需审核，请联系老师报名')
              }
              resolve(hasExam)
            })
            .catch((e) => {
              Toast(`${e.Message || '获取审核失败！'}`)
              hasExam = false
              resolve(hasExam)
            })
        })
      },
      refresh() {
        let url = this.getRefreshUrl()
        // const query = this.$route.query
        // if (query) url += query
        // alert(url)
        window.location.href = url
      },
      getRefreshUrl() {
        const origin = location.origin
        const pathname = location.pathname
        const query2 = JSON.parse(JSON.stringify(this.$route.query))
        const redirect = qs.stringify(query2)
        let url = `${origin}${pathname}#${this.$route.path}?${redirect}`
        return url
      },
      async getWXOpenId(code) {
        const tenant = await store.getters['user/getTenant']
        store
          .dispatch('user/GetWechatOpenId', {
            Code: code,
          })
          .then(async (data) => {
            const { Code, Data } = data
            if (Code === 0) {
              storage.set('openid', Data)
            } else {
              console.log('获取openId失败')
            }
            this.refresh()
          })
          .catch((e) => {
            this.refresh()
            console.log('获取openId失败')
          })
      },
      async getCode() {
        await store
          .dispatch('user/WechatGetAppID')
          .then((data) => {
            const { Code, Data } = data
            if (Code !== 0) {
              Notify('获取appId失败，请稍后重试！')
              return
            }
            const appId = Data.AppId
            const state = Data.State
            const origin = location.origin
            const pathname = location.pathname
            const query2 = JSON.parse(JSON.stringify(this.$route.query))
            const redirect = qs.stringify(query2)
            let url = `${origin}${pathname}#${this.$route.path}?${redirect}`
            url = encodeURIComponent(url)
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
          })
          .catch((e) => {
            Notify('获取appId失败，请稍后重试！')
          })
      },
      getUrlKey(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var rrr = decodeURIComponent(window.location.search)
        var r = rrr.substr(1).match(reg)
        if (r != null) return unescape(r[2])
        return null
      },
      async init() {
        const query = this.$route.query
        this.PackageName = query.packageName
        this.form.packageId = query.packageId
        this.form.packageDetailId = query.detailId
        this.form.secret = query.secret
        this.H5Url = await store.getters['system/getH5Url']
        // console.log('H5Url',this.H5Url)
        this.getDetail()
      },

      //付费版的立即抢购
      async payReciveCoupon() {
        //判断是否过了停售时间
        this.hasStopSell()
        const toast = Toast.loading({
          message: '领券中...',
          forbidClick: true,
          duration: 0,
        })
        let couponOrderNo = ''
        const result = await this.getRecive().then((res) => {
          couponOrderNo = res
        })
        if (!couponOrderNo) return
        const params = {
          type: 1,
          orderNo: couponOrderNo,
          openId: this.openid,
        }
        store
          .dispatch('service/PackageJsapiPayment', params)
          .then((data) => {
            const { Code, Data } = data
            console.log('data1', data)
            if (Code === 0) {
              if (Data.NeedPay === false) {
                // 实际支付为0元的无需唤醒支付
                this.$refs.REFPayStatus.show(0, 'done')
              } else {
                this.wxPay(Data, this.detail.SaleConfig.Price)
              }
            } else {
              Toast.fail('唤起支付失败')
            }
          })
          .catch((e) => {
            Toast.fail(e.Message || '唤起支付失败')
          })
      },
      // 唤起支付界面

      wxPay(data, Amount) {
        // console.log('data2',data)
        wx.chooseWXPay({
          timestamp: data.TimeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
          nonceStr: data.NonceStr, // 支付签名随机串，不长于 32 位
          package: data.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: data.SignType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: data.PaySign, // 支付签名
          success: (res) => {
            console.log('res', res)
            // 支付成功后展示
            this.$refs.REFPayStatus.show(data.OutTradeNo, Amount)
            // 支付成功后的回调函数
          },
          fail: (error) => {
            console.log(error)
          },
        })
      },

      // 免费领取
      async freerReciveCoupon() {
        //判断是否过了停售时间
        this.hasStopSell()
        const toast = Toast.loading({
          message: '领取中...',
          forbidClick: true,
          duration: 0,
        })
        // const H5Url = await store.getters['system/getH5Url']
        const result = await this.getRecive()
        // 判断是否需要审核
        // let resultExam = await this.isExamine()
        // if (resultExam) return

        // 判断是否开通支付
        if (!this.HasPaymentAbility) {
          setTimeout(() => {
            location.href = this.H5Url + 'service/#/home/index'
          }, 1000)
        } else {
          // 领取之后生成服务订单让后跳转支付界面
          this.useCoupon()
        }
      },
      //付费成功后去使用优惠券
      async payGoUseConpon() {
        // 判断是否要审核
        // const result = await this.isExamine()
        // if (result) return

        if (this.detail.EffectiveTime) {
          const effTime = new Date(this.detail.EffectiveTime).getTime()
          let nowDate = new Date().getTime()
          if (nowDate < effTime) {
            Toast(
              `${this.dateFormat(this.detail.EffectiveTime)}后可使用，敬请期待`
            )
            return
          }
        }
        this.useCoupon()
      },
      // 使用优惠券生成服务计划订单
      useCoupon() {
        const toast = Toast.loading({
          message: '生成服务计划订单中~',
          forbidClick: true,
          duration: 0,
        })
        // console.log('')
        // let detailId
        // if (this.detail.ReceiveMode === 0) {
        //   detailId = this.form.PackageDetailId
        // } else if (this.detail.ReceiveMode === 1) {
        //   detailId = this.detail.PackageDetailId
        // }

        let params = {
          packageDetailId: this.ownDetailId || this.detail.PackageDetailId,
        }
        store
          .dispatch('service/PackageUseCoupon', params)
          .then((data) => {
            const { Data } = data
            Toast.success('领取成功！即将跳转支付界面')
            setTimeout(() => {
              this.$go('Pay', {
                query: { type: 'coupon', orderNo: Data.OrderNo },
              })
            }, 1500)
          })
          .catch((e) => {
            Toast.fail(e.Message || '生成失败！')
          })
      },
      //只领券
      getRecive() {
        return new Promise((resolve, reject) => {
          let params = {}
          if (this.form.packageDetailId) {
            params.packageDetailId = this.form.packageDetailId
            params.secret = this.form.secret
          } else if (this.form.packageId) {
            params.packageId = this.form.packageId
          }
          store
            .dispatch('service/PackageReceiveCoupon', params)
            .then((data) => {
              const { Data } = data
              Toast.clear()
              this.detail.PackageStatus = Data.PackageStatus
              this.HasPaymentAbility = Data.HasPaymentAbility
              this.ownDetailId = Data.PackageDetailId
              // console.log('ownDetailId', this.ownDetailId)
              resolve(Data.CouponOrderNo)
            })
            .catch((e) => {
              // this.submitLoading = false
              Toast.fail(e.Message || '操作失败')
              reject(false)
            })
        })
      },

      //判断是否过了停售时间
      hasStopSell() {
        if (this.detail.SaleConfig && this.detail.SaleConfig.SaleEndTime) {
          const saleEndTime = new Date(
            this.detail.SaleConfig.SaleEndTime
          ).getTime()
          let nowDate = new Date().getTime()
          if (nowDate > saleEndTime) {
            Toast('已过停售时间')
          }
          return
        }
      },

      getDetail() {
        if (!this.form.packageId && !this.form.packageDetailId) return
        // let url = 'service/PackageGet'
        let url = 'service/PackageGetPackageInfoBeforeReceive'
        this.loading = true
        let params = {
          packageId: this.form.packageId,
          packageDetailId: this.form.packageDetailId,
          secret: this.form.secret,
        }

        store
          .dispatch(url, params)
          .then((data) => {
            const { Data } = data
            this.detail = Data
            console.log('detail', this.detail)
            // this.form = Data
            if (this.detail.Deadline) {
              this.detail.Deadline = dateFormat(this.detail.Deadline)
            }
            if (this.detail.EffectiveTime) {
              this.detail.EffectiveTime = dateFormat(this.detail.EffectiveTime)
            }
            wxShare(
              `${Data.ProductName}`,
              `点击领取【${Data.ProductName}】优惠券`
            )
          })
          .catch((e) => {
            this.detail = e.Data
            if (e.Code == 1005) {
              const toast = Toast.success({
                message: e.Message || '即将跳转到学习页',
                duration: 1500,
              })

              setTimeout(() => {
                location.href = this.H5Url + 'service/#/home/index'
              }, 1500)
            } else {
              Toast(e.Message)
            }
          })
          .finally((e) => {
            this.loading = false
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  h4 {
    text-align: center;
    padding: 16px 0;
    margin: 0;
  }
  .coupon-content {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .coupon {
    color: #fff;
    margin-top: 24px;
    width: 100%;
    height: 150px;
    background: #fa5151;
  }
  .coupon-text1 {
    display: flex;
    align-items: center;
    padding: 0 20px;
    background-image: radial-gradient(
        circle at right bottom,
        #fff,
        #fff 20px,
        transparent 21px
      ),
      radial-gradient(circle at left bottom, #fff, #fff 20px, transparent 21px);
    border-bottom: 1px dashed #fff;
    height: 75px;
    margin-bottom: -1px;
    .coupon-money {
      width: 40%;
      .icon {
        font-size: 12px;
      }
      .price {
        font-size: 28px;
      }
    }
    .coupon-name {
      width: 60%;
      font-size: 16px;
    }
  }
  .coupon-text2 {
    padding: 10px 0;
    box-sizing: border-box;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 75px;
    background-image: radial-gradient(
        circle at right top,
        #fff,
        #fff 20px,
        transparent 21px
      ),
      radial-gradient(circle at left top, #fff, #fff 20px, transparent 21px);
  }
  .van-btn {
    width: 100%;
    margin-top: 60px;
    font-weight: bold;
    font-size: 16px;
  }
  .count-down {
    margin-top: 20px;
    font-size: 14px;
    justify-content: center;
    display: flex;
    .time {
      color: red;
      margin-left: 10px;
    }
    .text {
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
